export const english = {
  common: {
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    continue: 'Continue',
    delete: 'Delete',
    edit: 'Edit',
    error: 'An error occurred, please try again.',
    readMore: 'Read more...',
    back: 'Back',
  },
  lookup: {
    allCategories: 'All categories',
    allCompanies: 'All companies',
    allColors: 'All colors',
    allSeasons: 'All seasons',
    imageType: {
      0: 'All image types',
      1: 'Enviroment images',
      2: 'Product images',
    }
  },
  home: {
    hero: {
      title: 'One of Sweden\'s largest image banks within home & garden, fashion & beauty and food & beverage',
      imageBelongsTo: 'Image belongs to',
    },
    search: {
      tags: {
        placeholder: 'Search for images with keywords, e.g.house, interior, kitchen, etc...',
        noData: 'No keywords found'
      },
      showOnlyNewProducts: 'Show only new products',
    },
    images: {
      loadMoreImages: 'Load more images',
      noImagesFound: 'No images found',
      noImagesFoundText: 'Try again with e.g. other keywords to broaden the search.',
      contactUsIfMissing: 'Contact us at <a href="mailto:info@pretopia.se">info@pretopia.se</a> if You are missing any images from our suppliers.',
      newProduct: 'New product',
      info: 'Info',
      download: 'Download image',
      onlyJournalistTooltip: 'Only journalists are authorized to download images from other suppliers.',
      missingCountryTooltip: 'You cannot download this image because the supplier has chosen not to publish their images in Your country. <br /> One reason for that could be, for example, that there is no dealer there.',
      missingCountryInfoTitle: 'Country selection does not match',
      missingCountryInfoContent: 'The supplier in question has chosen that their images should only be published in',
      onlyJournalistInfoTitle: 'You do not have permission to download images',
      onlyJournalistInfoContent: 'Only journalists are authorized to download images from other suppliers.'
    },
    companyButtons: {
      title: 'Suppliers in our image bank'
    },
    mainInfoBoxes: {
      title: 'Pretopia - an image bank for newspaper and magazines',
      content: 'For You as a freelance writer or editorial office worker, You can quickly and easily search our website for images from suppliers in the home, interior and garden sectors.',
      boxTitle1: 'Exposure to newsrooms in the home & garden, fashion & beauty and food & beverage sector',
      boxContent1: 'For You as a manufacturer or supplier who want to reach out with your products and news, Pretopia is an excellent platform. Here you have the opportunity to reach out to freelance writers and editors at newspapers and magazines throughout Europe.Journalists from many of the major magazines today use our image bank for their editorial material.Upload your photos and Pretopia will do the rest.',
      boxContentLinkText1: 'Create an account today',
      boxTitle2: 'Simple image management',
      boxContent2: 'For those who want to ease the workload, outsource your image processing to us at Pretopia.When journalists or your clients want to recieve press images for download, you can easily refer to us.If you need help converting or editing images, we\'ll help you with that.With our tool for uploading, tagging and categorizing images, you don\'t have to put an effort in, instead you let the image bank do the work for you.',
      boxContentLinkText2: 'If You need help, contact us!',
      boxTitle3: 'Download fast and simple',
      boxContent3: 'For those of you who are freelance writers or work in an editorial office, Pretopia is an excellent tool.Since we have several years of experience in editorial work, we know that you probably spend a disproportionate amount of time searching for the right images and news you need for inspiration, news or Collection pages.The image bank contains both exposed Product images and enviromental images.Our goal is that you don´ t have to search any further than here at Pretopia.',
      boxContentLinkText3: 'Create an account',
      boxContentLinkText4: 'and start downloading all you need - completely free of charge!',
    },
    customerQuotes: {
      meyenberg: {
        quote: 'Pretopia\'s image bank is easy to use, and has given Meyenberg good publicity in several media.I also value the professional and quick feedback, as well as the clear mounthly reports.',
        title: 'Founder / CEO',
      },
      miljogarden: {
        quote: 'After about a year with Pretopia, our visibility in relevant magazines has increased significantly.This has been a fantastic opportunity for us to spread our Miljögården.com brand to a wider audience, which is something we have been striving for a long time. Pretopia\'s service has not only been cost-effective and easy to use, but the staff have also been incredibly engaged and helpful, which has made the collaboration positive and a pure pleasure.',
        title: 'Marketing Manager',
      },
      haboGruppen: {
        quote: 'Pretopia has helped us for several years to reach out with images for our brands Habo and Muurikka. It has given us greater visibility in various channels, mostly in several interior design magazines. We can replace images whenever we want, which makes the image bank very flexible and with content that we easily update when, for example, a new product launches. Every month we receive clear reports, where we see which images have been downloaded and this gives us good insights into how our images are used.',
        title: 'Marketing and Communications Manager',
      },
      scandinaviskSpismiljo: {
        quote: 'We are very pleased with our collaboration with Pretopia. We have gained a completely different visibility and presence in the media since we started using the tool in early 2022. The staff is very service oriented and professional and it is quick and easy to upload pictures and information on their website. I really recommend to start using their tools. Many thanks for our cooperation!',
        title: 'Sales and Marketing Manager',
      },
      beslagDesign: {
        quote: 'Pretopia has helped us reach out to relevant press with our imagery in an efficient and flexible way, which has resulted in us receiving many more press clippings than before. We are also grateful for the monthly summary, which gives us an overview of which images have been downloaded and used. Pretopia has really facilitated our press processing and we can highly recommend their services.',
        title: 'Media and Communications Manager',
      },
      sweefFurniture: {
        quote: 'We at Sweef Furniture are very satisfied with the image bank Pretopia, as well as the service and additional services that are added. The number of press clippings and introductions we received is beyond expectations! It is also very much appreciated to receive quick notices about our mentions. We have long requested a collective image bank for the interior design industry, which we now appreciate with Pretopia.',
        title: 'PR Manager',
      },
      almedahlsHome: {
        quote: 'We have been using Pretopia since the beginning of 2022 and are very satisfied. Pretopia\'s staff shows great commitment and the service simplifies things a lot for us. It is easy to upload images, texts and to replace them when we have new ones we want to show. Customers and the press find us and we have been featured in many newspapers. We can warmly recommend Pretopia!',
        title: 'Sales and Marketing',
      },
      byBenson: {
        quote: 'When we started working with Pretopia, we didn\'t know much about them or the outcome, but we are more than satisfied! And every month they deliver nice compilations of very nice publications. Many thanks for that. It\'s such a smooth service!',
        title: 'CEO',
      },
      idyllien: {
        quote: 'Vi är jättenöjda med Pretopia - vi har snabbt nått ut till fler och nya kunder genom att finnas på Pretopia och på så sätt kommit med i flera populära tidningar!',
        title: 'Grundare',
      },
      potPaws: {
        quote: 'During my journey with POT PAWS®, I have done most things by myself with a few exceptions. One of these is that I have taken the help of professional, smart Pretopia image bank so that my images can reach out more easily. It turned out to be a really good idea. A total of 13 times my POT PAWS® have been in magazines during the spring! It has felt absolutely fantastic and a bit magical to see how they "pawed" out into the world. I feel grateful that you at Pretopia gave me the opportunity to be part of your smart image bank and I highly recommend this to anyone who wants to reach out more easily with their products.',
        title: 'Owner and Founder',
      },
      himlekok: {
        quote: 'We have been using Pretopia for two years and are incredibly satisfied. Pretopia are both professional and committed to their assignments. Two qualities that we as a customer really value and which have resulted in good publicity and exposure of our brand.',
        title: 'Vice President',
      },
      anebyhusgruppen: {
        quote: 'We have been using Pretopia for about a year now and we notice that our images have a greater impact than before and are used frequently in different media. The tool is simple and user-friendly and is a flexible way to reach out to new and old partners.',
        title: 'Marketing Manager',
      },
      ireMobelAB: {
        quote: 'Pretopia image bank is easy to handle, flexible & gives good feedback on downloads.<br> Always helpful and have a nice reception. <br>Thumbs up!',
        title: 'Marketing Coordinator',
      },
      dCor: {
        quote: 'Pretopia has been a cost-effective way for us to get publicity in several magazines over the past year. The tool is also easy to use and the collaboration works very well.',
        title: 'Sales',
      },
    },
  },
  aboutUs: {
    title: 'About Us',
    content: 'Pretopia\'s image bank is a small but powerful tool for you who are a supplier and want to reach out to writers and editors at the country\'s major newspapers and magazines in home, interior design and garden, fashion and beauty as well as food and beverage. As a press and media professional, you can easily create an account and download images for free. We at Pretopia mainly do two things, on the one hand we provide an image bank that both has a wide variety and contains both environmental and product images and on the other hand we use our contact network of freelancers and editors to whom we send out newsletters and product launches.',
    subTitle1: 'Extensive experience of the industry',
    subContent1: 'We have solid experience in the newspaper industry and this means that we know what challenges exist for both suppliers and those who work in newsrooms. As a supplier, we know that it can be difficult to get effective exposure to writers and editors when you make new product launches or in general want to increase awareness of your product portfolio. We also know that you, who are active in the media, have a big challenge to find the right images for your editorial material, something that can often be time-consuming. <br>With this knowledge in the back of our minds, we have created a "win/win" situation between suppliers and the media. Our goal has become to invite suppliers who bring a varied range of press images to our affiliated newsrooms and freelance writers.',
    subTitle2: 'SOME OF THE BIGGEST NEWSPAPERS IN THE INDUSTRY ARE AVAILABLE WITH US',
    subContent2: 'At Pretopia you will find Plaza Kök&Bad, Plaza Villa&Hus, Hem Ljuva Hem, Aftonbladet Härligt Hemma, Sköna hem, Lantliv, Amelia, Aller Media, Residence, MediaExtra, HusExtra and a host of other titles and freelance writers. For you as a supplier, Pretopia\'s image bank therefore becomes an extremely valuable asset in your marketing arsenal.',
    subTitle3: 'QUESTIONS AND FEEDBACK?',
    subContent3: 'Send us an email to the address <a href="mailto:info@pretopia.se">info@pretopia.se</a>',
    imageBelongsTo: 'Image belongs to',
  },
  contactUs: {
    address: 'Postal address',
    phone: 'Phone number',
    email: 'Email',
    jennySubtitle: 'CEO and Partner',
    mickeSubtitle: 'Developer and Partner',
    ceciliaSubtitle: 'Social Media Manager',
    contactForm: {
      title: 'How can we help You?',
      subtext1: 'Do you have questions about our services and subscriptions?',
      subtext2: 'Send us a message and we will get back to you as soon as possible.',
      subtitle: 'Leave your details and we will contact you',
      companyName: 'Company name',
      name: 'Your name',
      emailOrPhone: 'Email or phone number *',
      message: 'Message *',
      send: 'Send',
      thanks: 'Thank you for your message!',
    }
  },
  vendorPrice: {
    title: 'Choose the right subscription for you',
    subtitle: 'There is a solution for every type of business, regardless of size.',
    contactUs: 'Contact Us',
    contactUsLinkText: 'Contact us and we´ll discuss Your wishes.',
    info: 'The subscription can be upgraded to a higher level at any time during the year.<br /> It is also possible to buy more space for more pictures or newsletters, regardless of subscription. Let us know how many photos you want your account to hold or how many newsletters you want and we\'ll get back to you with an offer. <br /> We also offer total administration of the account as we replace, remove and add images according to your wishes.<br />',
    infoTitle: 'Don´t find a subscribtion that suits You? <br />We tailor a package according to your wishes!',
    package: {
      basic: {
        title: 'Reach out to the country\'s most important newsrooms and freelance writers.',
        value1: 'Member of the image bank and thus unique access to the country\'s major magazines',
        value2: '30 images in the image bank',
        value3: 'Free support',
        value4: 'Download statistics',
        value5: 'Monthly ROI reports',
        price: 'SEK 550/month without commitment period, 1 month notice period. Binding period one year for annual packages when the entire amount is invoiced at one and the same time, SEK 6,050/year (SEK 550/discount).<br /> Price PUFF member: SEK 4,500/year',
      },
      standard: {
        mostPopular: 'Most popular',
        title: 'For those of you who want to get more out of your membership with us.',
        value1: 'Member of the image bank and thus unique access to the country\'s major magazines',
        value2: 'Publicity under the news page on Pretopia\'s home page of at least one Instagram post',
        value3: '50 images in the image bank',
        value4: '5 exposures in social media (in consultation with you)',
        value5: '1 exclusive newsletter (in consultation with you)',
        value6: 'Free support',
        value7: 'Download statistics',
        value8: 'Monthly ROI reports',
        value9: 'Sporadic participation in social media may occur',
        price: 'SEK 1,070/month. Binding period 12 months. No automatic renewal - we will contact you. <br /> If the amount is instead invoiced at one and the same time, SEK 11,770/year (SEK 1,070 discount.<br /> Price PUFF member: SEK 9,000/year',
      },
      premium: {
        title: 'For those who want even more exposure.',
        value1: 'Member of the image bank and thus unique access to the country\'s major magazines',
        value2: 'Publicity under the news page on Pretopia\'s home page of at least one Instagram post',
        value3: 'Free counseling',
        value4: '100 images in the image bank',
        value5: '10 exposures in social media (in consultation with you)',
        value6: '2 exclusive newsletters (in consultation with you)',
        value7: 'Free support',
        value8: 'Download statistics',
        value9: 'Monthly ROI reports',
        value10: 'Sporadic participation in social media may occur',
        price: 'SEK 1,700/month. Binding period 12 months. No automatic renewal - we will contact you. <br /> If the amount is instead invoiced at one and the same time, SEK 18,700/year (SEK 1,700 discount).<br /> Price PUFF member: SEK 15,000/year'
      },
      premiumPlus: {
        title: 'For those who want a bit more of everything...',
        value1: 'Member of the image bank and thus unique access to the country\'s major magazines',
        value2: 'Publicity under the news page on Pretopia\'s home page of at least one Instagram post',
        value3: 'Free counseling',
        value4: '150 images in the image bank',
        value5: '12 exposures in social media (in consultation with you)',
        value6: '3 exclusive newsletters (in consultation with you)',
        value7: 'Free support',
        value8: 'Download statistics',
        value9: 'Monthly ROI reports',
        value10: 'Sporadic participation in social media may occur',
        price: 'SEK 2,090/month. Binding period 12 months. No automatic renewal - we will contact you.<br /> If the amount is instead invoiced at one and the same time, SEK 22,990/year (SEK 2,090/discount).<br /> Price PUFF member: SEK 18,000/year'
      },
      grande: {
        title: 'Maximize your impact in all channels',
        value1: 'Member of the image bank and thus unique access to the country\'s major magazines',
        value2: 'Publicity under the news page on Pretopia\'s home page of at least one Instagram post',
        value3: 'Free counseling',
        value4: '200 images in the image bank',
        value5: '15 exposures in social media (in consultation with you)',
        value6: '4 exclusive newsletters (in consultation with you)',
        value7: 'Free support',
        value8: 'Download statistics',
        value9: 'Monthly ROI reports',
        value10: 'Sporadic participation in social media may occur',
        price: 'SEK 2,520/month. Binding period 12 months. No automatic renewal - we will contact you.<br /> If the amount is instead invoiced at one and the same time, SEK 27,720/year (SEK 2,520/discount.<br /> Price PUFF member: SEK 21,500/year'
      }
    }
  }, resetPassword: {
    title: 'Enter your new password',
    password: 'Password',
    passwordHint: 'At least 6 characters',
    passwordChangedMessage: 'Your password has been changed. You can now log in with your new password.',
  }, vendors: {
    dashboard: {
      myProfile: 'My profile',
      editAccountInformation: 'Edit company information',
      company: 'Company',
      name: 'Name',
      orgNumber: 'Organization number',
      address: 'Address',
      postAddress: 'Postal address',
      email: 'Email',
      phone: 'Phone number',
      description: 'Description',
      uploadImages: 'Upload images',
      imageAdministration: 'Image administration',
      accountInfoText: 'Here you can manage your images via the image administration, see statistics or find out which editors downloaded your images. <br />If you have any questions, please contact us at <a href="mailto:info@pretopia.se">info@pretopia.se</a>',
      companyAccountInfoTitle: 'Company information',
      userAccountInfoTitle: 'User Information',
      editInformation: 'Edit information',
      downloadTop3: 'Downloaded Top 3',
      downloads: 'Downloads',
      imagesForReview: 'Images for review',
      rejectedImages: 'Rejected images',
      acceptedLanguages: 'Countries in which your images may be published',
      youCanChangeThis: 'You can change these under "Edit information"',
    },
    list: {
      saveAllImages: 'Save all images',
      savedSuccessfullyMessage: 'The images and information have been saved and have now been submitted for review.',
      savedButMissingInformationMessage: 'The images and information have been saved but one or more images are missing <br />category, tags and/or colors and they cannot be moved to the review!',
      new: 'New',
      review: 'Under review',
      approved: 'Approved',
      rejected: 'Rejected',
      saveHintText: 'Remember to select a category and at least one tag/keyword on each image for it to be submitted for review.',
      removeSelectedImages: 'Remove selected images',
      removeErrorMessage: 'One or more images could not be deleted.',
      selectAllImages: 'Select all images',
      selectAllImagesHintText: 'Tip: You can select multiple images by holding down CTRL or SHIFT while clicking on the images',
      categoryMissing: 'Category missing',
      uploadImages: 'Upload images',
      imageInfoMessage1: 'Upload the images by clicking the button above. <br />You then select the images and fill in the information below. <br />It is fine to select several pictures at the same time.',
      imageInfoMessage2: 'Add relevant tags/keywords on the images to make users find your image when they search.',
      imageInfoMessage3: 'When you\'re done, you click save and then the images are sent for review before they become searchable!',
      tags: 'Tags / Keywords',
      mainCategory: 'Main category',
      category: 'Category',
      description: 'Image description',
      descriptionInSwedish: 'Description in Swedish',
      descriptionInEnglish: 'Description in English/Other language',
      swedish: 'Swedish',
      english: 'English',
      typeOfImage: 'Image type',
      environmentImage: 'Environment image',
      productImage: 'Product image',
      color: 'Color / Pattern',
      missingColorText: 'Are you missing a color? <a href="mailto:info@pretopia.se">Click here</a> to send us an email.',
      price: 'Swedish price',
      englishPrice: 'English price',
      season: 'Season',
      newProduct: 'New product',
      selectLaunchDate: 'Select launch date',
      externalUrl: 'Enter a link address if you want to refer to your own image bank or website',
      unsavedChangesTitle: 'Unsaved changes',
      unsavedChangesMessage: 'You have unsaved changes.<br /> Do you want to continue without saving?',
    },
    approved: {
      nonApprovedImages: 'No images have been approved',
      categoryMissing: 'Category is missing',
      changeVisibility: 'Change visibility',
      nrOfDownloads: '{count} downloads',
      editImage: 'Edit image',
      deleteImage: 'Delete image',
    },
    rejected: {
      nonRejectedImages: 'No photos have been rejected',
      infoSavedWaitingForApproval: 'The image information has been saved and is now awaiting approval.',
      categoryMissing: 'Category is missing',
    },
    review: {
      nonReviewedImages: 'No images have been saved for review',
      categoryMissing: 'Category is missing',
    },
    upload: {
      uploadImages: 'Upload images',
      dragDropText: 'Drag and place your images here or click here to select images on your computer.',
      imageSizeText: 'The images should be larger than 1.5 MB in order for them to be used, e.g. in print.',
      uploadingImages: 'Uploading {fileCount} image(s), please wait...',
      fileSizeWarning: 'Some of the images you tried to upload are too small in size. <br /> Minimum size is 1.5 MB.',
      uploadError: 'An error occurred while trying to upload one or more of the images.',
      file: 'File',
      uploadNotSupported: 'Your browser does not support file upload!',
    }
  },
  components: {
    head: {
      menu: {
        home: 'Home',
        contactUs: 'Contact',
        aboutUs: 'About us',
        createAccount: 'Create account',
        myProfile: 'My profile',
        myImages: 'My images',
        login: 'Log in',
        logout: 'Log out',
        journalist: 'Journalist',
        loginAsJournalist: 'Log in as a journalist / user',
        createAccoutAsJournalist: 'Create account as journalist / user',
        company: 'Supplier',
        loginAsCompany: 'Log in as a supplier',
        createAccountAsCompany: 'Create an account as a supplier',
        switchCompany: 'Switch company',
      },
    }, footer: {
      policy: 'Policy & Terms',
      contactUs: 'Contact us',
      followUs: 'Follow us',
    },
    common: {
      category: 'Category',
      cookieSnackbarText: 'We use cookies to make the website work well for you.By continuing to surf, you agree to this.',
      whatIsCookies: 'What is cookies?',
      iUnderstand: 'I understand',
      wordFromOurCustomers: 'A few words from our customers',
      missingImages: 'Are you missing an image from our suppliers?',
      contactUsForHelp: 'Contact us at <a href="mailto:info@pretopia.se">info@pretopia.se</a> and we will help You.',
      addItem: '+ Add',
      addTagsHint: 'Press the ENTER or TAB key to add the tag',
      allCountries: 'All countries',
      selectAllCountries: 'Select all countries',
      countries: 'Countries',
    },
    dialog: {
      acceptLicense: {
        title: 'License Media use',
        contentText1: 'By becoming a user at Pretopia AB, you agree to the following license terms:',
        contentText2: 'The suppliers of the images must be stated when images are used in both printed and digital media and websites. Unless a photographer is listed for the photos, only the supplier\'s name needs to be included.',
        contentText3: 'By becoming a customer of Pretopia AB, the supplier accepts the following license terms:',
        contentText4: 'Leverantören är ensam och fullt ansvarig för de digitala bildfiler som de överför när de använder Pretopias bildbank. The supplier is solely and fully responsible for the digital image files they transfer when using Pretopia\'s image bank. The supplier has full responsibility for owning the rights to the images. You guarantee that Pretopia or any of its employees shall not be held liable for any failure to comply with this obligation.',
        confirmLicense: 'Yes, I accept the license terms'
      },
      companySelect: {
        title: 'Select company',
        label: 'Select company...',
      },
      cookies: {
        title: 'Cookies',
        contentText1: 'A cookie is a small text file that the website you visit requests to save on your computer.',
        contentText2: 'Cookies and similar technologies are used on many websites to give a visitor access to various features. It is sometimes possible to use the information in the cookie to follow how users surf.',
        contentText3: 'According to the Electronic Communications Act, everyone who visits a website with cookies must have access to information about the website containing cookies and the purpose of the use of cookies. The visitor must also give his consent to the use of cookies.',
        contentText4: 'Exceptions to this are when cookies are needed to transmit an electronic message via an electronic communication network or when the processing is necessary to provide a service that the user has expressly requested.',
      },
      imageDetails: {
        newProduct: 'New product',
        description: 'Description',
        launchDate: 'Launch date',
        season: 'Season',
        price: 'Product price',
        externalUrl: 'Link to the supplier\'s image bank or website',
        clickHereToOpenExternalUrl: 'Click here to visit the supplier',
        company: 'Company',
        phone: 'Phone number',
        email: 'Email',
        imageInformation: 'Image information',
        dimensions: 'Dimensions',
        imageAddedAt: 'Image added at',
        download: 'Download image',
        onlyJournalistTooltip: 'Only journalists are authorized to download images from other suppliers.',
        missingCountryTooltip: 'You cannot download this image because the supplier has chosen not to publish their images in your country. <br /> One reason for that could be, for example, that there is no dealer there.',
        missingCountryInfoTitle: 'Country selection does not match',
        missingCountryInfoContent: 'The supplier in question has chosen that their images should only be published in',
        onlyJournalistInfoTitle: 'You do not have permission to download images',
        onlyJournalistInfoContent: 'Only journalists are authorized to download images from other suppliers.'
      },
      imageEditDetails: {
        message: 'Message',
        note: 'NOTE!',
        editWarningText: 'Editing approved images will move them to "Under Review".',
        description: 'Description',
        category: 'Category',
        tags: 'Tags / Keywords',
        color: 'Color / Pattern',
        typeOfImage: 'Image type',
        environmentImage: 'Enviroment image',
        productImage: 'Product image',
        newProduct: 'New product',
        launchDate: 'Launch date',
        productIsNew: 'The product is new',
        selectLaunchDate: 'Select launch date',
        season: 'Season',
        price: 'Product price',
        swedishPrice: 'Swedish price',
        englishPrice: 'English price',
        externalUrl: 'Link to the supplier\'s image bank or website',
        company: 'Company',
        phone: 'Phone number',
        email: 'Email',
        imageInformation: 'Image information',
        dimensions: 'Dimensions',
        confirmDeleteTitle: 'Confirm delete',
        confirmDeleteText: 'Are you sure you want to delete this image?',
        confirmDeleteButtonText: 'Yes, delete the image',
        clickHereToOpenExternalUrl: 'Click here to visit the supplier',
        swedish: 'Swedish',
        english: 'English',
      },
      login: {
        loginCompany: 'Log in as a supplier',
        login: 'Log in',
        email: 'Email',
        password: 'Password',
        loginFailedMessage1: 'Incorrect username/password. Try again.',
        loginFailedMessage2: 'If you recently created the account and it has not yet been approved, you will receive an email from us when you can use the service. <br>If you have any questions, please contact us at info@pretopia.se and we will help you.',
        forgotYourPassword: 'Have you forgotten the password?',
        noAccountLinkText: 'Don\'t have an account? Click here to create one.',
      },
      resetPassword: {
        enterYourEmail: 'Enter your email address',
        emailAddress: 'Email address',
        resetError: 'The email address was not found or the account is not active.',
        sendResetMailSuccessMessage: 'An email has been sent to you with a link to the reset page.',
        missingAccount: 'Don\'t have an account? Click here to create one.',
        resetPassword: 'Reset password',
        enterNewPassword: 'Enter your new password',
        password: 'Password',
        passwordHint: 'At least 6 characters',
        resetSuccessMessage: 'The password has been changed and you can now log in.',
      },
      signup: {
        createAccount: 'Create an account',
        selectUserType: 'Select user type:',
        editorial: 'Editorial',
        freelance: 'Freelance',
        company: 'Company/Magazine *',
        publisher: 'Publisher',
        name: 'Your name *',
        email: 'Email address *',
        emailExistsError: 'The email address already exists',
        password: 'Password *',
        confirmPassword: 'Confirm password *',
        accept: 'Yes, I accept',
        licenseTerms: 'License terms',
        readLicenseTerms: 'Read the license terms here',
        createAccountError: 'An error occurred. Check that all fields are filled in and try again.',
        mandatory: 'Mandatory',
        mandatoryAndMinChars: 'Mandatory and at least 6 characters',
        passwordNotMatch: 'The passwords must match each other',
        invalidEmail: 'Invalid email address',
        selectCountry: 'Select the country you are targeting *',
      },
      signupCompany: {
        createCompanyAccount: 'Create supplier account',
        welcomeMessage: 'Glad to see you want to use our services! <br />Enter the information below and we will contact you as soon as possible.',
        name: 'Company name *',
        contactName: 'Contact name *',
        phoneOrEmail: 'Phone number or email *',
        message: 'Message',
        createAccountError: 'An error occurred. Check that all fields are filled in and try again.',
        send: 'Send',
        mandatory: 'Mandatory',
      },
      signupWaitingForVerification: {
        title: 'Welcome to Pretopia!',
        contentText1: 'Thank you for creating an account with us at Pretopia!',
        contentText2: 'We will go through the information and get back to you shortly via email.',
        contentText3: 'Once your account is approved, you can log in and start downloading images.',
      },
      userEdit: {
        editAccount: 'Edit account',
        selectUserType: 'Select user type:',
        editorial: 'Editorial',
        freelance: 'Freelance',
        company: 'Company/Magazine *',
        publisher: 'Publisher',
        name: 'Your name *',
        email: 'Email address',
        selectCountry: 'In which country will the images you download be published? *',
        otherMultipleCountriesSelected: 'More countries your downloaded images will be published in',
        editAccountError: 'An error occurred. Check that all fields are filled in and try again.',
        mandatory: 'Mandatory',
        password: 'New password *',
        confirmPassword: 'Confirm the new password *',
        mandatoryAndMinChars: 'Mandatory and at least 6 characters',
        passwordNotMatch: 'The passwords must match each other',
        changePassword: 'Change password',
      },
    }
  }
}
